import {
  DirectSalesProductTemplateTargetFilter,
  DirectSalesRangeSet,
  ProductTemplateRulesResponse,
} from 'components/common/types/DirectSalesProductTemplate.types';
import { DEFAULT_REQUEST_FORMAT_CRITERIA } from 'consts/targetCriteria';
import { ProductTarget, SelectionPermission } from 'store/productManagement/reducer.types';

const { greenTolerance, orangeTolerance, priority } = DEFAULT_REQUEST_FORMAT_CRITERIA;

export const transformTarget = (
  rule: ProductTemplateRulesResponse,
  selectionPermission: SelectionPermission,
): ProductTarget | undefined => {
  const { behaviour } = rule;

  if (behaviour === 'RANGE') {
    const {
      min,
      max,
      default: defaultValue,
      defaultGreenTolerance,
      defaultOrangeTolerance,
      defaultPriority,
    } = rule.rangeSet[0] as DirectSalesRangeSet[0];

    return {
      selectionPermission,
      minValue: min ?? undefined,
      maxValue: max ?? undefined,
      defaultValue: defaultValue ?? undefined,
      greenTolerance: (defaultGreenTolerance ?? greenTolerance) * 100,
      orangeTolerance: (defaultOrangeTolerance ?? orangeTolerance) * 100,
      priority: {
        code: String(defaultPriority ?? priority),
        name: String(defaultPriority ?? priority),
      },
    };
  }

  if (behaviour === 'FIXED') {
    const fixed = rule.fixedSet[0] as DirectSalesProductTemplateTargetFilter;

    return {
      selectionPermission,
      value: fixed.target,
      greenTolerance: (fixed.defaultGreenTolerance ?? greenTolerance) * 100,
      orangeTolerance: (fixed.defaultOrangeTolerance ?? orangeTolerance) * 100,
      priority: {
        code: String(fixed.defaultPriority),
        name: String(fixed.defaultPriority),
      },
    };
  }

  return { selectionPermission };
};
